module.exports = __webpack_public_path__ + "static/media/forwardhead_normal_right.6da9f758.png";